import React from 'react';
import './Loading.css';

const Loading = () => {
    return (
        <div className="loader-overlay">
            <img src="/kntu-logo.png" alt="logo" className='loader'/>
            <div></div>
        </div>
    );
};

export default Loading;